/**
 * Holly Filters - AJAX Filtreleme ve Sıralama
 */

(() => {
  class HollyFilters {
    constructor() {
      this.selectors = {
        filterForms: 'form[action*="/collections/"], form[action*="/search"]',
        filterInputs: 'input[type="checkbox"], input[type="range"], #min-price-input, #max-price-input, #mobile-min-price-input, #mobile-max-price-input',
        sortByLinks: '.sort-by__link, [data-sort-value], .link-dropdown__link[data-sort-value]',
        filterButtons: 'button[type="submit"]',
        applyButtons: 'button[onclick*="form.submit"]',
        activeFilters: '[data-active-filters]',
        removeFilterTag: '.filter-remove-tag',
        removeAllFilters: '.filter-remove-all'
      };

      this.filterContainer = document.querySelector('filter-container');
      this.setupFilterContainerHooks();
      this.init();
      
      this.setupMutationObserver();
      
      const debouncedInit = debounce(() => {
        if (window.hollyFilters) {
          window.hollyFilters.init();
          window.hollyFilters.checkFilterVisibility();
        }
      }, 100);
      
      this.filterContainer.renderSections = function (...args) {
        const result = originalRenderSections.apply(this, args);
        debouncedInit();
        return result;
      };
    }

    setupMutationObserver() {
      this.observer = new MutationObserver((mutations) => {
        let shouldReinit = false;
        
        mutations.forEach(mutation => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === 1) { // ELEMENT_NODE
                if (node.matches && (
                    node.matches(this.selectors.filterForms) || 
                    node.querySelector(this.selectors.filterForms) ||
                    node.querySelector(this.selectors.filterInputs)
                )) {
                  shouldReinit = true;
                }
              }
            });
          }
        });
        
        if (shouldReinit) {
          this.init();
          this.checkFilterVisibility();
        }
      });
      
      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    init() {
      this.initFilterInputsEvents();
      this.initSortByLinksEvents();
      this.initFilterButtonsEvents();
      this.initRangeInputsEvents();
      this.initFilterRemoveLinks();
      
      this.addInlineEventHandlers();
    }
    
    addInlineEventHandlers() {
      document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        if (!checkbox.hasAttribute('data-holly-handled')) {
          checkbox.setAttribute('data-holly-handled', 'true');
          checkbox.setAttribute('onclick', 'if(window.hollyFilters) window.hollyFilters.handleCheckboxChange(this)');
        }
      });
      
      document.querySelectorAll('input[type="range"]').forEach(range => {
        if (!range.hasAttribute('data-holly-handled')) {
          range.setAttribute('data-holly-handled', 'true');
          range.setAttribute('onchange', 'if(window.hollyFilters) window.hollyFilters.handleRangeChange(this)');
        }
      });
      
      // NOTE: Price text inputs are intentionally NOT bound here. They are
      // handled exclusively by holly-price-range.js, which applies the filter
      // only when focus leaves the whole price filter (or on Enter / preset),
      // so typing a min then clicking max no longer submits prematurely.
    }
    
    handleCheckboxChange(checkbox) {
      const form = checkbox.closest('form');
      if (form) {
        if (!checkbox.checked) {
          const filterName = checkbox.name;
          const filterValue = checkbox.value;
          
          const currentUrl = new URL(window.location.href);
          
          const params = new URLSearchParams();
          
          for (const [key, value] of currentUrl.searchParams.entries()) {
            if (key !== filterName || value !== filterValue) {
              params.append(key, value);
            }
          }
          
          const baseUrl = form.action.split('?')[0];
          const url = `${baseUrl}?${params.toString()}`;
          
          this.loadUrlWithAjax(url);
          return;
        }
        const event = new Event('change', {bubbles: true});
        this.handleFormSubmit(form, event);
      }
    }
    
    handleRangeChange(range) {
      const form = range.closest('form');
      if (form) {
        const event = new Event('change', {bubbles: true});
        this.handleFormSubmit(form, event);
      }
    }
    
    handlePriceChange(input) {
      const form = input.closest('form');
      if (form) {
        const event = new Event('change', {bubbles: true});
        this.handleFormSubmit(form, event);
      }
    }

    setupFilterContainerHooks() {
      if (this.filterContainer && !this.filterContainer._hollyFiltersHooked) {
        const originalHandleFetchResponse = this.filterContainer.handleFetchResponse;
        
        this.filterContainer.handleFetchResponse = function(responseHTML) {
          const result = originalHandleFetchResponse.call(this, responseHTML);
          
          HollyFilters.updateActiveFilters(responseHTML);
          
          return result;
        };
        
        if (this.filterContainer.renderSections) {
          const originalRenderSections = this.filterContainer.renderSections;
          const self = this;
          
          this.filterContainer.renderSections = function(...args) {
            const result = originalRenderSections.apply(this, args);
            
            const debouncedInit = debounce(() => {
                if (window.hollyFilters) {
                  window.hollyFilters.init();
                  window.hollyFilters.checkFilterVisibility();
                }
              }, 100);
              
              debouncedInit();
            
            return result;
          };
        }
        
        this.filterContainer._hollyFiltersHooked = true;
      }
    }

    static updateActiveFilters(responseHTML) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseHTML, 'text/html');
      
      const activeFilterElements = doc.querySelectorAll('[data-active-filters]');
      const currentActiveFilterElements = document.querySelectorAll('[data-active-filters]');
      
      for (let i = 0; i < currentActiveFilterElements.length; i++) {
        const currentElement = currentActiveFilterElements[i];
        
        if (activeFilterElements[i]) {
          currentElement.innerHTML = activeFilterElements[i].innerHTML;
          
          const filterTags = currentElement.querySelectorAll('.filter-remove-tag');
          if (filterTags && filterTags.length > 0) {
            currentElement.classList.add('holly-has-filters');
            currentElement.classList.remove('holly-no-filters');
            currentElement.style.display = 'flex'; 
          } else {
            currentElement.classList.add('holly-no-filters');
            currentElement.classList.remove('holly-has-filters');
            currentElement.style.display = 'none';
          }
        }
      }
      
      // AJAX tamamlandıktan sonra event listener'ları yeniden bağla
      if (window.hollyFilters) {
        // Tüm filtreleri yeniden başlat
        window.hollyFilters.init();
        window.hollyFilters.checkFilterVisibility();
        
        setTimeout(() => {
          window.hollyFilters.checkFilterVisibility();
        }, 50);
      } else {
        const hollyFilters = new HollyFilters();
        hollyFilters.initFilterRemoveLinks();
        hollyFilters.checkFilterVisibility();
      }
    }

    initFilterInputsEvents() {
      document.querySelectorAll(this.selectors.filterInputs).forEach(input => {
        if (input.type === 'checkbox') {
          input.addEventListener('change', (e) => {
            const form = e.target.closest('form');
            if (form) {
              if (form.hasAttribute('data-ajax-native')) {
                return true;
              }
              
              this.handleFormSubmit(form, e);
            }
          });
        }
      });
    }

    initRangeInputsEvents() {
      // Price text inputs are handled by holly-price-range.js (which applies
      // only when focus leaves the filter / on Enter / preset), so we no longer
      // submit on their 'change' event here — that caused the filter to apply
      // as soon as the min input lost focus (e.g. when clicking into max).

      const rangeInputs = document.querySelectorAll('input[type="range"]');
      rangeInputs.forEach(input => {
        input.addEventListener('change', (e) => {
          const form = e.target.closest('form');
          if (form) {
            if (form.hasAttribute('data-ajax-native')) {
              return true;
            }
            
            this.handleFormSubmit(form, e);
          }
        });
      });
    }

    initSortByLinksEvents() {
      const sortLinks = document.querySelectorAll('.sort-by__link, [data-sort-value], .link-dropdown__link[data-sort-value]');
      
      sortLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          if (link.hasAttribute('data-ajax-native') || link.closest('[data-ajax-native]')) {
            return true;
          }
          
          e.preventDefault();
          
          const sortingDropdown = link.closest('[x-data]');
          if (sortingDropdown && window.Alpine) {
            window.Alpine.evaluate(sortingDropdown, 'sortingOpen = false');
          }
          
          const sortValue = link.getAttribute('data-sort-value');
          
          if (!sortValue) {
            console.error('Sort değeri bulunamadı:', link);
            return;
          }
          
          const currentUrl = window.location.href;
          let newUrl;
          
          const questionMarkIndex = currentUrl.indexOf('?');
          
          if (questionMarkIndex === -1) {
            newUrl = `${currentUrl}?sort_by=${sortValue}`;
          } else {
            const basePath = currentUrl.substring(0, questionMarkIndex);
            
            const queryString = currentUrl.substring(questionMarkIndex + 1);
            
            const params = queryString.split('&');
            
            let hasSortBy = false;
            const newParams = params.map(param => {
              if (param.startsWith('sort_by=')) {
                hasSortBy = true;
                return `sort_by=${sortValue}`;
              }
              return param;
            });
            
            if (!hasSortBy) {
              newParams.unshift(`sort_by=${sortValue}`);
            }
            
            newUrl = `${basePath}?${newParams.join('&')}`;
          }
          
          newUrl = newUrl.replace(/([?&])page=[^&]*(&|$)/, '$1').replace(/&$/, '');
          
          
          this.loadUrlWithAjax(newUrl);
        });
      });
    }

    initFilterButtonsEvents() {
      document.querySelectorAll(this.selectors.filterButtons).forEach(button => {
        button.addEventListener('click', (e) => {
          const form = button.closest('form');
          if (form) {
            if (form.hasAttribute('data-ajax-native')) {
              return true;
            }
            
            this.handleFormSubmit(form, e);
          }
        });
      });

      document.querySelectorAll(this.selectors.applyButtons).forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const form = button.closest('form');
          if (form) {
            if (form.hasAttribute('data-ajax-native')) {
              return true;
            }
            
            this.handleFormSubmit(form, e);
          }
        });
      });
    }

    initFilterRemoveLinks() {
      document.querySelectorAll(this.selectors.removeFilterTag).forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          
          const removeUrl = new URL(link.href);
          
          // Page parametresini kaldır
          removeUrl.searchParams.delete('page');
          
          const currentUrl = new URL(window.location.href);
          const sortParam = currentUrl.searchParams.get('sort_by');
          
          if (sortParam && !removeUrl.searchParams.has('sort_by')) {
            removeUrl.searchParams.set('sort_by', sortParam);
          }
          
          this.loadUrlWithAjax(removeUrl.toString());
        });
      });

      document.querySelectorAll(this.selectors.removeAllFilters).forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          
          const clearUrl = new URL(link.href);
          clearUrl.searchParams.delete('page');
          
          const currentUrl = new URL(window.location.href);
          const sortParam = currentUrl.searchParams.get('sort_by');
          
          if (sortParam && !clearUrl.searchParams.has('sort_by')) {
            clearUrl.searchParams.set('sort_by', sortParam);
          }
          
          this.loadUrlWithAjax(clearUrl.toString());
        });
      });
    }

    checkFilterVisibility() {
      const activeFilterAreas = document.querySelectorAll(this.selectors.activeFilters);
      
      activeFilterAreas.forEach(area => {
        const filterTags = area.querySelectorAll(this.selectors.removeFilterTag);
        const removeAllButton = area.querySelector(this.selectors.removeAllFilters);
        
        if (filterTags && filterTags.length > 0) {
          area.classList.add('holly-has-filters');
          area.classList.remove('holly-no-filters');
          area.style.display = 'flex';
        } else {
          area.classList.add('holly-no-filters');
          area.classList.remove('holly-has-filters');
          area.style.display = 'none';
        }
      });
      
      this.addGlobalCSS();
    }
    
    addGlobalCSS() {
      if (document.getElementById('holly-filters-css')) {
        return;
      }
      
      const styleTag = document.createElement('style');
      styleTag.id = 'holly-filters-css';
      
      styleTag.innerHTML = `
        .holly-has-filters {
          display: flex !important;
        }
        .holly-no-filters {
          display: none !important;
        }
      `;
      
      document.head.appendChild(styleTag);
    }

    handleFormSubmit(form, event) {
      if (!form) return;
      
      if (form.hasAttribute('data-ajax-native')) {
        return true;
      }
      
      if (form.classList.contains('main-search__form')) {
        return true;
      }
      
      event.preventDefault();
      
      const formData = new FormData(form);
      let params = new URLSearchParams();
      
      const addedParams = new Set();
      
      const currentUrl = new URL(window.location.href);
      const sortParam = currentUrl.searchParams.get('sort_by');
      if (sortParam) {
        params.append('sort_by', sortParam);
        addedParams.add(`sort_by=${sortParam}`);
      }
      
      // Önce fiyat filtreleri dışındaki tüm parametreleri ekle
      for (const [key, value] of currentUrl.searchParams.entries()) {
        if (key === 'sort_by' || key === 'page' || key.includes('filter.v.price')) continue;
        
        const paramKey = `${key}=${value}`;
        if (!addedParams.has(paramKey)) {
          params.append(key, value);
          addedParams.add(paramKey);
        }
      }
      
      const isPriceChanged = form.hasAttribute('data-price-filters-changed');
      
      let minValue = null;
      let maxValue = null;
      
      for (const [key, value] of formData.entries()) {
        if (key.includes('filter.v.price.gte')) {
          minValue = parseInt(value);
        } else if (key.includes('filter.v.price.lte')) {
          maxValue = parseInt(value);
        }
      }
      
      if (isPriceChanged) {
        const maxRange = form.querySelector('input[type="range"].thumb--right');
        const maxRangeValue = maxRange ? parseInt(maxRange.max) : 1500;
        
        if (minValue !== null && minValue > 0) {
          params.append('filter.v.price.gte', minValue);
        }
        
        if (maxValue !== null && maxValue < maxRangeValue) {
          params.append('filter.v.price.lte', maxValue);
        }
      } else {
        const currentMinPrice = currentUrl.searchParams.get('filter.v.price.gte');
        const currentMaxPrice = currentUrl.searchParams.get('filter.v.price.lte');
        
        if (currentMinPrice) {
          params.append('filter.v.price.gte', currentMinPrice);
        }
        
        if (currentMaxPrice) {
          params.append('filter.v.price.lte', currentMaxPrice);
        }
      }
      
      for (const [key, value] of formData.entries()) {
        if (!key.includes('filter.v.price')) {
          const paramKey = `${key}=${value}`;
          if (!addedParams.has(paramKey)) {
            params.append(key, value);
            addedParams.add(paramKey);
          }
        }
      }
      
      // Merchant request: whenever a price filter is applied, also sort the
      // results by price ascending (low to high) and hide out-of-stock items
      // (availability = 1).
      if (isPriceChanged) {
        params.delete('sort_by');
        params.append('sort_by', 'price-ascending');

        if (!params.getAll('filter.v.availability').includes('1')) {
          params.append('filter.v.availability', '1');
        }
      }

      const baseUrl = form.action.split('?')[0];
      const url = `${baseUrl}?${params.toString()}`;

      this.loadUrlWithAjax(url);
    }

    loadUrlWithAjax(url) {
      let normalizedUrl = url;
      if (normalizedUrl.startsWith('/')) {
        normalizedUrl = window.location.origin + normalizedUrl;
      }
      
      const currentUrl = window.location.href;
      if (normalizedUrl === currentUrl) {
        return;
      }
      
      if (this.filterContainer && typeof this.filterContainer.ajaxLoadUrl === 'function') {
        this.filterContainer.ajaxLoadUrl(url);
        
        const self = this;
        const reinitEvents = () => {
          self.init();
          self.checkFilterVisibility();
        };
        
        setTimeout(reinitEvents, 300);
        setTimeout(reinitEvents, 600);
        setTimeout(reinitEvents, 900);
        setTimeout(reinitEvents, 1200);
      } else {
        window.location.href = url;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    window.hollyFilters = new HollyFilters();
  });

  document.addEventListener('shopify:section:load', () => {
    window.hollyFilters = new HollyFilters();
  });
  
  document.addEventListener('shopify:section:render', () => {
    if (window.hollyFilters) {
      window.hollyFilters.checkFilterVisibility();
    } else {
      window.hollyFilters = new HollyFilters();
    }
  });
})(); 